/**
 * Configuration and strategy selection for hover optimization
 */
export class HoverOptimizationConfig {
  // Thresholds for different optimization strategies
  static readonly WORKER_THRESHOLD = 2000; // Use Web Worker for lines with >2000 points
  static readonly SIMPLIFICATION_THRESHOLD = 5000; // Use line simplification for very long lines
  static readonly LOD_THRESHOLD = 10000; // Use level-of-detail for extremely long lines
  
  /**
   * Determine the best hover optimization strategy based on route complexity
   */
  static getOptimizationStrategy(lineLength: number): 'basic' | 'worker' | 'simplified' | 'lod' {
    if (lineLength > this.LOD_THRESHOLD) {
      return 'lod';
    } else if (lineLength > this.SIMPLIFICATION_THRESHOLD) {
      return 'simplified';
    } else if (lineLength > this.WORKER_THRESHOLD) {
      return 'worker';
    }
    return 'basic';
  }
  
  /**
   * Get the appropriate simplification tolerance based on line length
   */
  static getSimplificationTolerance(lineLength: number): number {
    if (lineLength > 10000) {
      return 0.0001; // ~11 meters at equator
    } else if (lineLength > 5000) {
      return 0.00005; // ~5.5 meters at equator
    }
    return 0.00002; // ~2.2 meters at equator
  }
  
  /**
   * Check if Web Workers are supported
   */
  static isWorkerSupported(): boolean {
    return typeof Worker !== 'undefined';
  }
  
  /**
   * Get hover layer width based on zoom level
   */
  static getHoverLayerWidth(zoom: number): number {
    // Wider hover area at lower zoom levels
    if (zoom < 10) {
      return 50;
    } else if (zoom < 12) {
      return 40;
    } else if (zoom < 14) {
      return 30;
    }
    return 20;
  }
}